import { render } from "./DashboardMyEvents.vue?vue&type=template&id=2fbde233&scoped=true&ts=true"
import script from "./DashboardMyEvents.vue?vue&type=script&lang=ts"
export * from "./DashboardMyEvents.vue?vue&type=script&lang=ts"

import "./DashboardMyEvents.vue?vue&type=style&index=0&id=2fbde233&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbde233"]])

export default __exports__